import Accordion from '../components/accordion';

export default class AccordionSection {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;

        this.init();
    }

    init() {
        const accordion = this.el.querySelector('.accordion__items[data-accordion=accordion]');
        if (!accordion) return;

        new Accordion('.accordion__items[data-accordion=accordion]', {
            default: 0,
        });
    }
}
